<template>
  <el-form
    :model="editForm"
    ref="editForm"
    label-width="100px"
    :hide-required-asterisk="false"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-row>
      <el-col :span="24">
        <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
          <el-tab-pane label="详细描述" name="0">
            <span><div id="wangEditor"></div></span>
          </el-tab-pane>
          <el-tab-pane label="解决方案" name="1">
            <span><div id="wangEditor2"></div></span>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col style="margin-top: 15px">
        <el-form-item label="验证是否通过" prop="isChecking">
          <el-radio-group v-model="editForm.isChecking">
            <el-radio label="1">通过</el-radio>
            <el-radio label="0">不通过</el-radio>
          </el-radio-group>
          <span style="color: #d9001b; margin-left: 30px; vertical-align: sub"
            ><img src="@/img/warning.svg" alt="" />
            问题验证不通过，将重新激活</span
          >
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="上线时间" prop="sxsj">
          <div style="position: relative">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.sxsj"
              style="width: 150px"
              :clearable="false"
              disabled
              size="small"
            ></el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <el-col style="line-height: 40px">附件</el-col>
      <el-col :span="24" style="margin-top: 15px">
        <el-row>
          <el-col :span="8">
            <!-- <el-form-item key="12"> -->
            <el-upload
              action="#"
              class="upload-demo"
              ref="upload"
              :headers="headers"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :auto-upload="false"
              multiple
              :limit="5"
            >
              <el-button type="primary" icon="el-icon-upload" plain
                >选择附件</el-button
              >
            </el-upload>
            <!-- </el-form-item> -->
          </el-col>
          <el-col :span="16" style="line-height: 40px">
            <div>(单个文件不能超过50M，支持所有扩展名)</div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <!-- <el-form-item label=""> -->
        <el-table
          :data="editForm.file"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="文件名称"
            align="left"
            prop="filename"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="上传时间"
            align="left"
            prop="uploadtime"
            min-width="200px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="上传阶段"
            align="left"
            prop
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.xm }}{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="left"
            min-width="100px"
            :show-overflow-tooltip="true"
            fixed
          >
            <template slot-scope="scope">
              <el-button type="text" @click="handleDownloadFile(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <!-- </el-form-item> -->
      </el-col>
      <el-col
        style="
          line-height: 40px;
          display: flex;
          margin: 15px 0;
          justify-content: space-between;
        "
      >
        <div>
          <span style="font-weight: 700; font-size: 16px">评论</span>
          共{{ editForm.pinglun.length }}条评论
        </div>
        <el-button type="primary" @click="handleAddComment">评论</el-button>
      </el-col>
      <el-col :span="24">
        <span>
          <div id="wangEditor3"></div>
        </span>
      </el-col>
      <el-col>
        <div
          v-for="item in editForm.pinglun"
          :key="item.id"
          class="zpsm-comment-item"
        >
          <div class="top">
            <div>{{ item.username ? item.username[0] : "" }}</div>
            <div>{{ item.username }}</div>
          </div>
          <div class="middle">
            <!-- <span v-html="item.content"></span> -->
            <div>
              <span
                v-for="(picItem, picIndex) in item.commnetSlice"
                :key="picIndex"
              >
                <span v-if="picItem && picItem.picBig">
                  <span>
                    <el-image
                      style="max-width: 200px"
                      :src="picItem.srcBig"
                      :preview-src-list="[picItem.srcBig]"
                    >
                    </el-image>
                  </span>
                </span>
                <span v-else v-html="picItem"></span>
              </span>
            </div>
          </div>
          <div class="bottom">{{ item.create_time }}</div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  formatMomentDate,
  sizeFormat,
  cutContent,
  getPicList,
} from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {
  getQuestionDetail,
  checkQuestion,
  saveComment,
  uploadFile,
} from "@/api/question.js";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },

      editForm: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
        isChecking: 0,
        sxsj: null,
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      activeEditor: "0",
      parentDialog: false,
      fullscreenLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    let editor3 = new wangEditor(`#wangEditor3`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    editor3 = this.editorConfig(editor3);

    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
    this.editor3 = editor3;
  },
  methods: {
    getData(isComment) {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (isComment) {
            this.editForm.pinglun = res.data.pinglun;
          } else {
            this.editForm = res.data;
            if (this.editForm.sxsj) {
              this.editForm.sxsj = moment(this.editForm.sxsj + "");
            }
            this.editForm.isChecking = "1";
            this.editor.txt.html(this.editForm.detail);
            this.editor2.txt.html(this.editForm.jjfa);
            this.editor.disable();
            this.editor2.disable();
          }
          if (this.editForm.pinglun && this.editForm.pinglun.length > 0) {
            for (let i in this.editForm.pinglun) {
              const picList = getPicList(this.editForm.pinglun[i].content);
              this.editForm.pinglun[i].commnetSlice = cutContent(
                picList,
                this.editForm.pinglun[i].content
              );
            }
          }
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },

    saveForm() {
      const params = {
        ...this.editForm,
      };
      if (this.editForm.isChecking == 0) {
        // this.handleAddComment();
      }
      if (this.editor3.txt.html()) {
        saveComment({
          id: this.mxParams.id,
          status: this.editForm.status,
          content: this.editor3.txt.html(),
        });
      }
      checkQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.fullscreenLoading = false;

          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };
      if (!params.content) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.editor3.txt.html("");
          this.getData(true);
        }
      });
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(status) {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          this.fullscreenLoading = true;
          if (fileLen > 0) {
            //上传文件
            form.append("id", this.mxParams.id);
            form.append("type", "验证");
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(status);
              }
            });
          } else if (fileLen == 0) {
            this.saveForm(status);
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.url;
      window.open(url);
    },

    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>